<div #funnel style="font-family: Poppins !important">
  <main>
    <article #fs fullscreen-able [class.is-active]="isActive" style="background-color: white;">
      <div style="background-color: #ffff;">
        <icon-chart
          [headerConfig]="headerConfig"
          [iconList]="iconList"
          [data]="currentVisibleData"
          [pageKey]="pageKey"
          [heading]="heading"
          [chartName]="divId"
          [config]="funnelChartContainer"
          [expand]="fs"
          [fullscreen]="isFullscreen"
          [item]="item"
          (screenChanges)="fullscreenChanges($event)"
        ></icon-chart>
        
      </div>

      <div *ngIf="isLoading" style="position: relative; height: 500px; width: 100%;">
        <loading></loading>
      </div>
      <div class="dynamic-mode-toggle" *ngIf="hasDynamicColumns">
          <button [class.active]="dynamicDisplayMode === 'multi'" (click)="setDynamicMode('multi')">Cards</button>
          <button [class.active]="dynamicDisplayMode === 'super'" (click)="setDynamicMode('super')">Breakdown</button>
      </div>

      <div #funnelChartContainer [style.display]="isLoading ? 'none' : ''">
        <div [style.display]="noData?'none':''" id="funnelChart" style="width:100%;"></div>
      </div>
      <div style="height: 500px; width: auto;" *ngIf="noData">
        <span class="bg-text">{{ error_name ? error_name : 'There is no data for this time period' }}</span>
      </div>

    </article>
  </main>
</div>
